import type { AggregatedProgress, LocalDayRecord } from "./types";

export function aggregateFromDays(days: readonly LocalDayRecord[]): AggregatedProgress {
  let doneCount = 0;
  let skippedCount = 0;
  let snoozeCount = 0;
  let score1 = 0;
  let score2 = 0;
  let score3 = 0;

  for (const day of days) {
    if (day.status === "done") doneCount++;
    if (day.status === "skipped") skippedCount++;
    if (day.status === "snoozed") snoozeCount++;
    if (day.discomfortScore === 1) score1++;
    if (day.discomfortScore === 2) score2++;
    if (day.discomfortScore === 3) score3++;
  }

  return {
    doneCount,
    skippedCount,
    snoozeCount,
    score1,
    score2,
    score3,
    activeDays: days.filter((d) => d.status !== "pending").length,
  };
}

/** Server merge: monotonic max per counter */
export function mergeProgress(
  local: AggregatedProgress,
  remote: AggregatedProgress | null,
): AggregatedProgress {
  if (!remote) return local;
  return {
    doneCount: Math.max(local.doneCount, remote.doneCount),
    skippedCount: Math.max(local.skippedCount, remote.skippedCount),
    snoozeCount: Math.max(local.snoozeCount, remote.snoozeCount),
    score1: Math.max(local.score1, remote.score1),
    score2: Math.max(local.score2, remote.score2),
    score3: Math.max(local.score3, remote.score3),
    activeDays: Math.max(local.activeDays, remote.activeDays),
  };
}
